import { TranslateService } from '@ngx-translate/core';
import { PromotionCatalogTypeGiftService } from './../../../../services/promotion/promotion-catalog-type-gift.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/components/common/api';

@Component({
  selector: 'app-catalog-gift-type-detail',
  templateUrl: './catalog-gift-type-detail.component.html',
  styleUrls: ['./catalog-gift-type-detail.component.css']
})
export class CatalogGiftTypeDetailComponent implements OnInit {

  catalogTypeGiftFields: any;
  form: FormGroup;
  invalidSubmit: boolean;
  catalogTypeGiftId: number;
  timeout: any;
  router: Router;

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private catalogTypeGiftService: PromotionCatalogTypeGiftService,
    private translate: TranslateService,
    public confirmationService: ConfirmationService
  ) { }

  get f() {
    return this.form.controls;
  }

  ngOnInit() {

    this.catalogTypeGiftId = this.activatedRoute.snapshot.params['id'];

    this.catalogTypeGiftService.getCatalogTypeGiftFields().subscribe(res => this.catalogTypeGiftFields = res );

    if (this.catalogTypeGiftId) {
      this.catalogTypeGiftService.getCatalogTypeGift(this.catalogTypeGiftId).subscribe(catalogTypeGiftData => {
        // Se Catalogo Tipologia Esistente, popolo il Form
        this.form = this.fb.group({
          code: [catalogTypeGiftData['code']],
          description: [catalogTypeGiftData['description']],
          template_reserv: [catalogTypeGiftData['template_reserv']],
          template_pickup: [catalogTypeGiftData['template_pickup']],
          template_delete: [catalogTypeGiftData['template_delete']]
        });
      });
    }
    else {
      this.form = this.fb.group({
        code: [''],
        description: [''],
        template_reserv: [''],
        template_pickup: [''],
        template_delete: ['']
      });
    }

  }

  save(){
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const catalogTypeGiftData = {
      code: this.f.code.value,
      description: this.f.description.value,
      template_reserv: this.f.template_reserv.value,
      template_pickup: this.f.template_pickup.value,
      template_delete: this.f.template_delete.value
    }

    if (this.catalogTypeGiftId) {
      this.catalogTypeGiftService.updateCatalogTypeGift(this.catalogTypeGiftId, catalogTypeGiftData).subscribe(() => window.history.back());
    }
    else{
      this.catalogTypeGiftService.createCatalogTypeGift(catalogTypeGiftData).subscribe(() => window.history.back());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog-gift-type/catalog-gift-type-detail/catalog-gift-type-detail.component.ts